import React, { useState, useEffect } from "react";
import Card from "./components/card";
import { Col, Row, Space } from "antd";
import phone from "./images/phone.svg";
import mail from "./images/mail.svg";
import location from "./images/location.svg";
import time from "./images/time.svg";

const Contacts = () => {
  return (
    <div style={{
      background: "#F7F7F7",
      paddingTop: 30,
      paddingBottom: 40
    }}>
      <div className="margin-100-x">
        <h2 className="bolded text-center">Kontaktai</h2>
        <Row gutter={[32, 32]} className="mt-3">
          <Col span={24} md={{ span: 12 }} xl={{ span: 8 }} >
            <div className="transparent-card">
              <h3>
                Klientų aptarnavimas
              </h3>
              <div className="card-point with-link">
                <img src={phone} />
                <a href="tel:+37069000222">
                  +370 690 00 222
                </a>
              </div>
              <div className="card-point with-link mt-2">
                <img src={mail} />
                <a href="mailto:info@alsendo.lt">
                  info@alsendo.lt
                </a>
              </div>
            </div>
          </Col>
          <Col span={24} md={{ span: 12 }} xl={{ span: 8 }} >
            <div className="transparent-card">
              <h3>
                Pardavimai
              </h3>
              <div className="card-point with-link">
                <img src={phone} />
                <a href="tel:++37065828980">
                  +370 658 28980
                </a>
              </div>
              <div className="card-point with-link mt-2">
                <img src={mail} />
                <a href="mailto:pardavimai@alsendo.lt">
                  pardavimai@alsendo.lt
                </a>
              </div>
            </div>
          </Col>
          <Col span={24} md={{ span: 12 }} xl={{ span: 8 }} >
            <div className="transparent-card">
              <h3>
                Biuras
              </h3>
              <div className="card-point">
                <img src={location} />
                <a href="https://www.google.com/maps/place/Saul%C4%97tekio+al.+15,+10224+Vilnius/@54.7234513,25.3353895,17z/data=!3m1!4b1!4m6!3m5!1s0x46dd96e7d8146b07:0xbe2be6e772af696!8m2!3d54.7234482!4d25.3379644!16s%2Fg%2F11bytnwmbt?entry=ttu" target="_blank">
                  Vilnius, Saulėtekio al. 15, LT-10224
                </a>
              </div>
              <div className="card-point mt-2">
                <img src={time} />
                <p>
                  I - V
                  <span className="bolded">8:00 - 17:00 val.</span>
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Contacts;
